import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconCursor = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 23.844 23.94'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M23.558,20.649 L20.578,23.641 C20.383,23.836 20.129,23.933 19.875,23.933 C19.621,23.933 19.366,23.836 19.173,23.641 L11.429,15.868 L7.660,19.652 C7.472,19.841 7.218,19.944 6.958,19.944 C6.881,19.944 6.805,19.935 6.729,19.917 C6.394,19.837 6.124,19.590 6.015,19.262 L0.053,1.309 C-0.066,0.950 0.027,0.555 0.293,0.288 C0.559,0.021 0.952,-0.072 1.310,0.047 L19.196,6.031 C19.522,6.141 19.769,6.412 19.848,6.749 C19.927,7.085 19.827,7.439 19.584,7.683 L15.816,11.466 L23.558,19.238 C23.947,19.628 23.947,20.259 23.558,20.649 ZM13.708,12.171 C13.514,11.976 13.417,11.721 13.417,11.466 C13.417,11.211 13.514,10.955 13.708,10.761 L17.042,7.414 L2.567,2.570 L7.392,17.100 L10.726,13.753 C11.115,13.363 11.743,13.363 12.131,13.753 L19.875,21.525 L21.451,19.944 L13.708,12.171 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconCursor.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
